import store from '@/store';
import RouterSection from '@/Layout/components/RouterSection';
import AlarmMsg from '@/utils/alarmMsg';

/**
 * 비즈메카 - 비즈 연동 프로모션 라우터
 */

export default {
	path: '/promotion',
	name: 'promotion',
	component: RouterSection,
	mode: 'history',
	children: [
		{
			path: 'landing',
			name: 'promotionLanding',
			component: () => import('@/views/promotion/landing.vue'),
		},
		{
			path: 'bizMeka/account',
			name: 'bizMekaAccount',
			component: () => import('@/views/promotion/bizmeka/account.vue'),
			props: route => ({ beforeType: route.query.beforeType }),
			beforeEnter: chklogin,
		},
	],
};

function chklogin(to, from, next) {
	// 로그인한 사람은 접근 권한 없음
	if (store.getters.isLoggedIn) {
		AlarmMsg.showMsg('올바른 접근 경로가 아닙니다.').then(() => {
			next({ name: 'home' });
		});
		return;
	}
	next();
}
